import React from 'react'

class ScrollBackward extends React.Component {
  render() {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="m6.308 8 4.526 4.525-.754.754L4.8 8l5.28-5.279.754.754z" fill={color(this.props)} fillRule="evenodd"/>
      </svg>
    )
  }
}

export function color(props) {
  if (props.light) {
    if (props.disabled === true) {
      return "#EAEAEA"
    } else {
      return "#343638"
    }
  }
  if (props.disabled === true) {
    return "#999"
  } else {
    return "#FFF"
  }
}

export default ScrollBackward
